import React from "react";
import { Form } from "react-bootstrap";

import { getFieldProps } from "../utils";

const FormSelect = ({
  formik,
  controlId,
  label,
  defaultOption = "Please select",
  options,
  onChange,
  required,
  labelMap = lv => (lv && lv.label) || "",
  ...props
}) => {
  if (!options) options = [{ value: "-", label: "-" }];
  return (
    <Form.Group controlId={controlId} {...props}>
      <Form.Label>
        {label}
        {required && <span className="text-danger">*</span>}
      </Form.Label>
      <Form.Control
        as="select"
        className="form-select"
        {...getFieldProps(formik, controlId)}
        onChange={
          onChange
            ? e => {
                formik.handleChange(e);
                onChange(e);
              }
            : formik.handleChange
        }
      >
        <option value="">{defaultOption}</option>
        {options.map(option => {
          return (
            <option key={option.value} value={option.value}>
              {labelMap(option)}
            </option>
          );
        })}
      </Form.Control>
      <Form.Control.Feedback type="invalid">
        {formik.errors[controlId]}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default FormSelect;
